import React, { useContext, forwardRef } from 'react'
import { Path } from 'react-native-svg'

import { IconContext } from '../context'

export const ArrowRightIcon = forwardRef<Path>((props, ref) => {
  const iconContext = useContext(IconContext)

  return (
    <Path
      d='M13.267 4.209a.75.75 0 00-1.034 1.086l6.251 5.955H3.75a.75.75 0 000 1.5h14.734l-6.251 5.954a.75.75 0 001.034 1.087l7.42-7.067a.996.996 0 00.3-.58.758.758 0 00-.001-.29.995.995 0 00-.3-.578l-7.419-7.067z'
      fill={iconContext.color}
    />
  )
})

export default ArrowRightIcon
